import { render, staticRenderFns } from "./MenuLeft.vue?vue&type=template&id=f0045ac6&scoped=true&"
import script from "./MenuLeft.vue?vue&type=script&lang=ts&"
export * from "./MenuLeft.vue?vue&type=script&lang=ts&"
import style0 from "./MenuLeft.vue?vue&type=style&index=0&id=f0045ac6&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0045ac6",
  null
  
)

export default component.exports